(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dk-inspiration-gallery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-dk-inspiration]').forEach((section)=>{const buttons=section.querySelectorAll('[data-filter]');const groups=section.querySelectorAll('[data-category-section]');buttons.forEach((button)=>{button.addEventListener('click',()=>{const filter=button.dataset.filter;buttons.forEach((item)=>{const active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',String(active))});groups.forEach((group)=>{group.hidden=filter!=='all'&&group.dataset.categorySection!==filter})})});section.querySelectorAll('[data-open-dialog]').forEach((button)=>{button.addEventListener('click',()=>{const dialog=document.getElementById(button.dataset.dialogId);if(dialog)dialog.showModal()})});section.querySelectorAll('dialog').forEach((dialog)=>{dialog.addEventListener('click',(event)=>{if(event.target===dialog)dialog.close()})});const copyStatus=section.querySelector('[data-copy-status]');section.querySelectorAll('[data-copy-text]').forEach((button)=>{button.addEventListener('click',async()=>{const text=button.dataset.copyText;try{await navigator.clipboard.writeText(text)}catch(error){const field=document.createElement('textarea');field.value=text;field.setAttribute('readonly','');field.style.position='fixed';field.style.opacity='0';document.body.appendChild(field);field.select();document.execCommand('copy');field.remove()}const originalLabel=button.getAttribute('aria-label');button.classList.add('is-copied');button.setAttribute('aria-label','Gekopieerd');if(copyStatus)copyStatus.textContent=button.dataset.copySuccess||'Gekopieerd';window.setTimeout(()=>{button.classList.remove('is-copied');if(originalLabel)button.setAttribute('aria-label',originalLabel)},1600)})});const fontInput=section.querySelector('[data-font-preview-input]');const fontPreviews=section.querySelectorAll('[data-font-preview]');if(fontInput){const fallback=fontInput.value;const params=new URLSearchParams(window.location.search);const supplied=params.get('tekst');if(supplied!==null&&supplied.trim()){fontInput.value=supplied.trim().slice(0,60)}const updatePreview=()=>{const previewText=fontInput.value.trim()||fallback;fontPreviews.forEach((preview)=>{preview.textContent=previewText})};updatePreview();fontInput.addEventListener('input',updatePreview);if(supplied!==null&&supplied.trim()){const target=section.querySelector('.dk-font-browser');if(target)target.scrollIntoView({block:'start'})}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
